import { createFileRoute } from '@tanstack/react-router';

import { CredentialsPage } from '../../pages/settings';

export const Route = createFileRoute('/_shell/settings/credentials')({
  component: CredentialsPage,
});
